/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friends_IntroInputs */

const en_friends_intro = /** @type {(inputs: Friends_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Friends are other households on this Dishly. You can suggest recipes to each other – they land in the inbox and only become yours when you save them.`)
};

const de_friends_intro = /** @type {(inputs: Friends_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freunde sind andere Haushalte auf diesem Dishly. Ihr könnt euch Rezepte vorschlagen – sie landen im Posteingang und werden erst beim Speichern zu euren.`)
};

/**
* | output |
* | --- |
* | "Friends are other households on this Dishly. You can suggest recipes to each other – they land in the inbox and only become yours when you save them." |
*
* @param {Friends_IntroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const friends_intro = /** @type {((inputs?: Friends_IntroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friends_IntroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_friends_intro(inputs)
	return en_friends_intro(inputs)
});